







import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Presentational from './presentational.vue';
import LoadingContainer from '@/components/Loading/container.vue';

@Component({
  components: {
    Presentational,
    LoadingContainer,
  },
})
export default class SubmitBtnContainer extends Vue {
  @Prop() public btnText!: string;
  @Prop() public onOverlay!: boolean;

  @Emit() public submit() {}

  private get value() {
    return this.btnText;
  }

  public entry() {
    this.submit();
  }
}
